export const types = {
  JOURNALENTRY_REQUESTS: 'journalEntryRequests',
  JOURNALENTRIES: 'journalEntries'
};
